export const STREAMING = 'Streaming'
export const DISTRIBUTION = 'Distribution'
export const LINEAR = 'Linear'
export const OTHER = 'Other'
export const MEDIA_COMPANY = 'Media Company'
export const MEDIA_COMPANY_COLON = 'Media Company:'
export const THEATRICAL_RELEASE = 'Theatrical Release'
export const MULTICHANNEL = 'Multichannel'
export const MULTIPLE = 'Multiple'

export const MEDIA_COMPANY_DISNEY = 'Media Company: The Walt Disney Company'
export const MEDIA_COMPANY_HULU = 'Media Company: Hulu'
export const MEDIA_COMPANY_AMAZON = 'Media Company: Amazon'
export const MEDIA_COMPANY_MGM = 'Media Company: MGM'
export const MEDIA_COMPANY_OTHERS = 'Others'
export const MEDIA_COMPANY_DISCOVERY = 'Warner Bros. Discovery'
export const MEDIA_COMPANY_MAX = 'Max'
export const MEDIA_COMPANY_VIACOMCBS = 'ViacomCBS'
export const MEDIA_COMPANY_PARAMOUNT = 'Paramount'
export const MEDIA_COMPANY_NBCUNIVERSAL = 'NBCUniversal'
export const MEDIA_COMPANY_PEACOCK = 'Peacock'

export const SOV_STREAMING = 'Share of Voice - Streaming'
export const SOV_DISTRIBUTION = 'Share of Voice - Distribution'
export const SOV_MEDIA_COMPANY = 'Share of Voice - Media Company'

export const HBO = 'HBO'
export const HBO_MAX = 'HBO Max'
export const HBO_AND_HBO_MAX = 'HBO & HBO Max'
export const HBO_OR_HBO_MAX = 'HBO/HBO Max'
export const HBO_MAX_OR_HBO = 'HBO Max/HBO'

export const STREAMIMG_NETWORKS = 'Hulu,Amazon,Netflix,Disney+,Apple TV+,HBO,HBO Max,Paramount+,Discovery+,Peacock'

export const SOV_MEDIA_COMPANY_ALL_NETWORK = ['Media Company: Netflix', 'Media Company: Warner Bros. Discovery', 'Media Company: ViacomCBS', 'Media Company: The Walt Disney Company', 'Media Company: Hulu', 'Media Company: NBCUniversal', 'Media Company: A&E', 'Media Company: Amazon', 'Media Company: MGM', 'Media Company: AMC', 'Media Company: Apple', 'Media Company: Fox', 'Media Company: LionsgateStarz', 'Media Company: Sony Entertainment', 'Media Company: A24']

export const SOV_MEDIA_COMPANY_NETWORK = ['Media Company: Netflix', 'Media Company: Warner Bros. Discovery', 'Media Company: ViacomCBS', 'Media Company: NBCUniversal', 'Media Company: A&E', 'Media Company: AMC', 'Media Company: Apple', 'Media Company: Fox', 'Media Company: LionsgateStarz', 'Media Company: Sony Entertainment', 'Media Company: A24']

export const SOV_MEDIA_COMPANY_DISNEY_HULU = ['Media Company: The Walt Disney Company', 'Media Company: Hulu']

export const SOV_MEDIA_COMPANY_AMAZON_MGM = ['Media Company: Amazon', 'Media Company: MGM']